// extracted by mini-css-extract-plugin
module.exports = {"card":"Travel_card__gxfYK","wrapper":"Travel_wrapper__NioY1","titleWrapper":"Travel_titleWrapper__0GiyQ","linksWrapper":"Travel_linksWrapper__iPuR8","link":"Travel_link__TvpyC"};